<div (click)="close()" class="text-center">{{messages}}</div>
